<template>
	<!-- Обязательные поля -->
	<div v-if="required" class="form-item" :class="{ error }">
		<div class="form-item__label">{{ label }}</div>

		<Select v-if="type === 'select'" :value="String(value)" @change="onSelect" :placeholder="label" :style="{ width: '100%' }">
			<Option v-for="option of options" :key="option.value" :value="String(option.value)">{{ option.text }}</Option>
		</Select>

		<Input v-else-if="type === 'text'" :value="value" @input="onInput" :placeholder="label">
			<template v-if="icon" #prefix><Icon :type="icon" /></template>
		</Input>

		<Password v-else-if="type === 'password'" :value="value" @input="onInput" :placeholder="label">
			<template v-if="icon" #prefix><Icon :type="icon" /></template>
		</Password>

		<div v-if="error" class="form-item__error">{{ error }}</div>
	</div>

	<!-- Необязательные поля -->
	<div v-else class="form-item" :class="{ error, hidden: !visibleFields }">
		<div class="form-item__label">{{ label }}</div>

		<Select v-if="type === 'select'" :value="String(value)" @change="onSelect" :placeholder="label" :style="{ width: '100%' }">
			<Option v-for="option of options" :key="option.value" :value="String(option.value)">{{ option.text }}</Option>
		</Select>

		<Input v-else-if="type === 'text'" :value="value" @input="onInput" :placeholder="label">
			<template v-if="icon" #prefix><Icon :type="icon" /></template>
		</Input>

		<Password v-else-if="type === 'password'" :value="value" @input="onInput" :placeholder="label">
			<template v-if="icon" #prefix><Icon :type="icon" /></template>
		</Password>

		<div v-if="error" class="form-item__error">{{ error }}</div>
	</div>
</template>

<script>
import { Icon, Input, Select } from "ant-design-vue"
const { Password } = Input
const { Option } = Select

export default {
	name: "UserCreate",
	components: {
		Icon,
		Select,
		Option,
		Input,
		Password
	},
	props: {
		label: { type: String, required: true },
		value: { type: String, required: true },
		type: { type: String, default: "text" },
		options: { type: Array, default: () => [] },
		icon: { type: String, default: null },
		required: { type: Boolean, default: false },
		visibleFields: { type: Boolean, default: false },
		error: { type: String, default: null }
	},
	methods: {
		onInput({ target }) {
			this.$emit("input", target.value)
		},
		onSelect(value) {
			this.$emit("input", value)
		}
	}
}
</script>

<style lang="scss" scoped>
$error-color: #ff7a7a;

.form-item {
	position: relative;
	margin-bottom: 15px;

	&:last-child {
		margin-bottom: 0;
	}

	&__label {
		margin-bottom: 3px;
		padding-left: 10px;
		font-weight: bold;
		color: #888;
	}
	&__error {
		// position: absolute;
		padding-left: 10px;
		font-size: 12px;
		color: $error-color;
	}

	&.error {
		.form-item__label {
			color: $error-color;
		}
		/deep/ .ant-input {
			border-color: $error-color !important;
		}
	}
	&.hidden {
		display: none;
	}
}
</style>
